var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9442 2.60693H17.4888L11.9296 8.96078L18.4696 17.6069H13.3488L9.33808 12.3631L4.74885 17.6069H2.20269L8.14885 10.8108L1.875 2.60693H7.12577L10.7512 7.40001L14.9442 2.60693ZM14.0512 16.0839H15.4612L6.35961 4.05001H4.84654L14.0512 16.0839Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/IconTwitter.646d9ea73a5e93c426c85e269b22a2e2.svg";
export { ForwardRef as ReactComponent };